import React from "react";
import FilterList from "../../../components/user/auxItems/auxItemsFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const AuxItemListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

AuxItemListPage.propTypes = {};

export default AuxItemListPage;
